import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import BaseResponse from '../../models/src/model/BaseResponse';
import {
  ALLOWED_IP_CREATE,
  ALLOWED_IP_LIST_REQUEST,
  ALLOWED_IP_REMOVE,
} from '../../constants/backoffice/ipConstants';

import {
  setAllowedIpList,
  setTotalCount,
} from '../../actions/backoffice/ipActions';
import {
  AllowedConnectionIpApi,
  AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest,
  AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest,
  AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest,
} from '../../models/src';
import AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse
  from '../../models/src/model/AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse';

const api = new AllowedConnectionIpApi(config.API_CLIENT);

// function getUrlVars() {
//   const vars = {};
//   const parts = window.location.href.replace(
//     /[?&]+([^=&]+)=([^&]*)/gi,
//     function (m, key, value) {
//       // eslint-disable-line
//       vars[key] = value;
//     },
//   );
//   return vars;
// }

function* refreshList(code, page, pageLength) {
  let listresult;
  let listdata;
  console.log(code);
  switch (code) {
    case 200:
      listresult = yield api.apiAllowedConnectionIpAllowedConnectionIpListPost(
        {
          allowedConnectionIpControllerDtoAllowedConnectionIpListRequest: new AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest(
            page,
            pageLength,
          ),
        },
        () => {},
      );
      listdata = api.apiClient.deserialize(
        listresult,
        AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse,
      );
      // console.log(listdata);
      yield put(setAllowedIpList(listdata.list));
      yield put(setTotalCount(listdata.totalCount));
      break;
    default:
      break;
  }
}

//= ====================================
//  WATCHERS
//-------------------------------------
function* allowedIpListRequestSaga(paylod) {
  try {
    const result = yield api.apiAllowedConnectionIpAllowedConnectionIpListPost(
      {
        allowedConnectionIpControllerDtoAllowedConnectionIpListRequest: new AllowedConnectionIpControllerDtoAllowedConnectionIpListRequest(
          paylod.page,
          paylod.pageLength,
        ),
      },
      () => {},
    );
    const data = api.apiClient.deserialize(result, AllowedConnectionIpControllerDtoAllowedConnectionIpListResponse);
    console.log(data);
    yield put(setAllowedIpList(data.list));
    yield put(setTotalCount(data.totalCount));
  } catch (e) {
    console.log(e);
  }
}
function* allowedIpCreateSaga(payload) {
  try {
    const requestData = new AllowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest();
    requestData.beginIpAddr = payload.beginIpAddr;
    requestData.endIpAddr = payload.endIpAddr;
    requestData.description = payload.description;
    console.log(requestData);
    const result =
      yield api.apiAllowedConnectionIpAllowedConnectionIpCreatePost(
        { allowedConnectionIpControllerDtoAllowedConnectionIpCreateRequest: requestData },
        () => {},
      );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log(data);
    yield refreshList(data.resultCode, payload.page, payload.pageLength);
  } catch (e) {
    console.log(e);
  }
}

function* allowedIpRemveSaga(payload) {
  try {
    const requestData = new AllowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest(
      payload.ipBlockNoArray,
    );
    console.log(requestData);
    const result =
      yield api.apiAllowedConnectionIpAllowedConnectionIpRemovePost(
        { allowedConnectionIpControllerDtoAllowedConnectionIpRemoveRequest: requestData },
        () => {},
      );
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log(data);
    yield refreshList(data.resultCode, payload.page, payload.pageLength);
  } catch (e) {
    console.log(e);
  }
}

function* ipRootSaga() {
  yield all([
    takeEvery(ALLOWED_IP_LIST_REQUEST, allowedIpListRequestSaga),
    takeEvery(ALLOWED_IP_CREATE, allowedIpCreateSaga),
    takeEvery(ALLOWED_IP_REMOVE, allowedIpRemveSaga),
  ]);
}

const ipSagas = [fork(ipRootSaga)];

export default ipSagas;
